import {gsap} from "../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {PlayerTile} from "./PlayerTile";

// Constructor
export class PlayerSelectTiles extends PIXI.Container {

  constructor() {
    super();

    this.tilesContainer = null;
    this.selectTiles = {};
  }

  build() {
    let tileYOffset = -2;

    this.tilesContainer = new PIXI.Container();
    ['player', 'left', 'center', 'right'].forEach((tileCode) => {
      this.selectTiles[tileCode] = new PlayerTile(tileCode);
      this.tilesContainer.addChild(this.selectTiles[tileCode]);
    })

    this.tilesContainer.mask = app.game.gridMask;

    this.selectTiles['left'].position.set(-app.game.player.dimension.width + 52, -(app.game.player.dimension.height / 2) + tileYOffset);
    this.selectTiles['center'].position.set(0, -(app.game.player.dimension.height) + tileYOffset);
    this.selectTiles['right'].position.set(app.game.player.dimension.width - 52, -(app.game.player.dimension.height / 2) + tileYOffset);

    this.addChild(this.tilesContainer);
  }

}
